import { HttpHeaders, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Component, Input, ViewChild, SimpleChanges, OnInit, OnChanges } from '@angular/core';
import { Message, MessageAttachment, MassCommService } from '../../../shared/index';
import { ApiService } from '../../../../shared/api/api.service';
import { AuthService } from '../../../../shared/auth/auth.service';
import { WebContent } from '../../../../shared/model/webcontent-model';
import { FileUpload } from 'primeng/fileupload';
import { WebContentType } from '../../../../shared/model/webcontenttype.model';
import { WebsiteServiceApiService } from 'src/app/shared/api/website-service-api.service';

/**
 * prep mass comm message for sending
 */
@Component({
  selector: 'wl-mass-comm-message-edit-send-attachments',
  templateUrl: 'mass-comm-message-edit-send-attachments.component.html',
  styleUrls: [],
  providers: [],
    standalone: false
})
export class MassCommMessageEditSendComponentAttachments implements OnInit {
  @Input() public message: Message = null;
  @Input() public readonly: boolean = false;
  @ViewChild('fileUploader', { static: false }) private _fileUploader: FileUpload;

  public loading: boolean = false;
  public uploadBaseUrl: string = '';
  public uploadUrl: string = '';
  public webContentTypes: WebContentType[] = [];
  public uploadWebContentTypeId: number = 0;
  public uploadFileError: string = '';
  public uploading: boolean = false;
  public showModal = false;

  /**
   * inject
   */
  public constructor(
    private _massCommService: MassCommService,
    private _authService: AuthService,
    private _apiService: WebsiteServiceApiService
  ) {}

  /**
   * init
   */
  public ngOnInit(): void {
    this.setupComponent();
  }

  /**
   * setup component
   */
  private async setupComponent(): Promise<void> {
    this.loading = true;

    this.uploadBaseUrl = `${this._apiService.getBaseUrl()}/website/v2/WebContent/WebContentType/${this.uploadWebContentTypeId}/WebContents`;

    try {
      this.webContentTypes = await this._massCommService.getWebContenTypes();
    } catch (e) {
    } finally {
      this.loading = false;
    }
  }

  /**
   * user clicked upload, indicating they want to upload something
   */
  public removeAttachment(attachment: MessageAttachment): void {
    if (!attachment || !this.message || !this.message.Attachments) return;

    let index = this.message.Attachments.indexOf(attachment);

    if (index < 0) return;

    this.message.Attachments.splice(index, 1);
  }

  /**
   * show the file selector modal
   */
  public showFileSelector(): void {
    this.uploadFileError = '';
    this.showModal = true;
  }

  /**
   * when the user picks a content type
   */
  public handleWebContenTypeChange() {
    // set endpoint that uploads files, creates webcontents, attaches to given content type id
    setTimeout(
      () =>
        (this.uploadUrl = `${this._apiService.getBaseUrl()}/website/v2/WebContent/WebContentType/${
          this.uploadWebContentTypeId
        }/WebContents`)
    );
  }

  /**
   * user clicked upload, indicating they want to upload something
   */
  public handleUploadClick(): void {
    if (this.uploading) return;

    this.uploading = true;
    this.uploadFileError = '';

    // upload to endpoint
    this._fileUploader.upload();
  }

  /**
   * user clicked upload, indicating they want to upload something
   */
  public handleFileUploadCancelClick(): void {
    if (this.uploading) return;

    this.showModal = false;
    this._fileUploader.clear();
  }

  /**
   * files error
   */
  public onUploadError($event: { error: HttpErrorResponse; files: any[] }) {
    this.uploading = false;
    this.uploadFileError = $event.error.message;
  }

  /**
   * files uploaded
   */
  public onUploadComplete($event: { originalEvent: HttpResponse<WebContent[]>; files: any[] }) {
    this.uploading = false;
    let webContents: WebContent[] = [];

    webContents = $event.originalEvent.body;

    this.showModal = false;

    // add web contents to message as attachment
    webContents.forEach((x) => {
      let ma: MessageAttachment = new MessageAttachment();
      ma.MessageId = this.message.MessageId;
      ma.AttachementId = 0;
      ma.FileName = x.ContentTitle;
      ma.ContentId = x.ContentID;
      this.message.Attachments.push(ma);
    });
  }
}
